import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from "rxjs";

@Injectable({
    "providedIn": "root"
})
export class WithCredentialsInterceptor implements HttpInterceptor {
    private oAuthService = inject(OAuthService);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.oAuthService.getAccessToken();
        if (!token) {
            return next.handle(request);
        }
        const requestWithToken = request.clone({
            setHeaders: { Authorization: `Bearer ${token}` }
        });

        return next.handle(requestWithToken);
    }
}
